<!-- Not Connected State -->
<app-not-connected 
  *ngIf="!isConnected"
  description="Connect a wallet to manage your CryptoPunks bids.">
</app-not-connected>

<!-- Connected State -->
<div *ngIf="isConnected" class="my-bids-container">

  <!-- Header with Tabs and Actions -->
  <div class="header-container">
    <!-- Tabs Navigation -->
    <div class="tabs-container">
      <div class="tab" [class.active]="activeTab === 'outgoing'" (click)="activeTab = 'outgoing'">
        <h2 class="tab-title">OUTGOING BIDS</h2>
      </div>
      <div class="tab" [class.active]="activeTab === 'incoming'" (click)="activeTab = 'incoming'">
        <h2 class="tab-title">INCOMING BIDS</h2>
      </div>
    </div>

    <!-- Actions -->
    <div class="header-actions">
      <div class="header-actions-menu" #headerActionsMenu>
        <button
          type="button"
          (click)="toggleHeaderActionsMenu($event)"
          class="icon-btn settings-btn"
          tippy
          [options]="{ content: 'Settings', placement: 'top', theme: 'punks' }">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor" aria-hidden="true">
            <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
          </svg>
        </button>
        <div class="header-actions-dropdown" *ngIf="headerActionsMenuOpen">
          <button
            type="button"
            class="menu-action-btn"
            (click)="openSettingsFromMenu()">
            Settings
          </button>
          <a
            *ngIf="activeTab === 'outgoing' && walletAddress"
            [routerLink]="['/', 'user', walletAddress]"
            class="menu-action-btn"
            (click)="closeHeaderActionsMenu()">
            Archived bids
          </a>
          <button
            type="button"
            class="menu-action-btn"
            [disabled]="loading || loadingIncomingBids"
            (click)="refreshBidsFromMenu()">
            Refresh
          </button>
        </div>
      </div>

      <!-- Incoming tab actions - Notifications -->
      <a
        *ngIf="activeTab === 'incoming'"
        [routerLink]="['/', 'notifications']"
        class="icon-btn notifications-btn"
        tippy
        [options]="{ content: 'Notifications', placement: 'top', theme: 'punks' }">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
          <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
        </svg>
      </a>

      <!-- Outgoing tab actions -->
      <a 
        *ngIf="activeTab === 'outgoing'"
        [routerLink]="['/', 'all']" 
        (click)="closeSidebar()" 
        class="icon-btn create-btn"
        tippy
        [options]="{ content: 'Create a new bid', placement: 'top', theme: 'punks' }">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
          <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/>
        </svg>
      </a>
      <button 
        *ngIf="activeTab === 'outgoing' && hasStashOutgoingBids"
        (click)="cancelAllBids()" 
        class="icon-btn cancel-all-btn"
        tippy
        [options]="{ content: 'Cancel all bids', placement: 'top' }">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
          <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Stash balance -->
  <div *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false && isConnected && stashAddress" class="stash-balance-section">
    <div *ngIf="loadingStash" class="stash-loading">
      <span>Loading stash balance...</span>
    </div>
    <div *ngIf="!loadingStash" class="stash-info">
      <span class="stash-label">Stash</span>
      <span class="stash-balance-value">{{ formattedStashBalance }} ETH</span>
      <span class="stash-separator">•</span>
      <a 
        [href]="stashEtherscanUrl" 
        target="_blank" 
        rel="noopener noreferrer"
        class="stash-address-link">
        <app-wallet-address [address]="stashAddress"></app-wallet-address>
      </a>
      <div class="stash-actions">
        <ng-template #arrowIcon>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
            <path d="M440-160v-326L336-382l-56-58 200-200 200 200-56 58-104-104v326h-80ZM160-600v-120q0-33 23.5-56.5T240-800h480q33 0 56.5 23.5T800-720v120h-80v-120H240v120h-80Z"/>
          </svg>
        </ng-template>
        <a 
          (click)="depositToStash()" 
          class="stash-action-link deposit-link"
          tippy
          [options]="{ content: 'Deposit', placement: 'top', theme: 'punks' }">
          <ng-container *ngTemplateOutlet="arrowIcon"></ng-container>
        </a>
        <a 
          (click)="withdrawFromStash()" 
          class="stash-action-link withdraw-link"
          [class.disabled]="false"
          [attr.aria-disabled]="!canWithdrawFlag"
          tippy
          [options]="{ content: 'Withdraw', placement: 'bottom', theme: 'punks' }">
          <ng-container *ngTemplateOutlet="arrowIcon"></ng-container>
        </a>
      </div>
    </div>
  </div>

  <ng-template #bidIdIcon let-id="id" let-additionalBidIds="additionalBidIds" let-bid="bid">
    <span
      *ngIf="id"
      class="bid-id-icon"
      tippy
      [options]="{
        content: getBidIdTooltipContent(id, additionalBidIds || [], bid),
        placement: 'bottom',
        interactive: true,
        allowHTML: true
      }">
      <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor">
        <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
      </svg>
    </span>
  </ng-template>

  <!-- Outgoing Bids Tab Content -->
  <div *ngIf="activeTab === 'outgoing'" class="tab-content">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
      <p>Loading bids...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <p>{{ error }}</p>
    </div>

    <!-- Bids List -->
    <div *ngIf="!loading && !error" class="bids-list">
      <div *ngIf="bids.length === 0" class="no-bids">
        <p>No bids found.</p>
      </div>

      <div *ngIf="bids.length > 0" class="bids-container">
      <div *ngFor="let bid of bids; trackBy: trackByBidId" class="bid-item">
        <div class="bid-info">
          <div class="bid-amount">

            <div>
              <span class="amount-value">{{ bid.bid_amount_eth }}</span><br/>
              <div class="amount-currency-row">
                <span class="amount-currency">ETH</span>
                <ng-container
                  *ngTemplateOutlet="bidIdIcon; context: { id: bid.id, additionalBidIds: bid.additionalBidIds, bid: bid }">
                </ng-container>
              </div>
            </div>
          </div>
          <div class="bid-details">

            <div class="bid-date" *ngIf="bid.expires_at">
              <span class="detail-value" style="font-weight: 600; font-size: 11px !important; opacity: 0.4">Expires on:</span><br />
              <span class="detail-value">{{ bid.formattedExpiresAt }}</span>
            </div>
            
            <div class="bid-tags">
              <div>
                <div *ngIf="bid.isConfidential" class="confidential-pill" title="Confidential bid">
                  <svg style="transform: scale(1.4);" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
                  <span>Confidential</span>
                </div>
                <div
                  *ngIf="bid.stash_funded === 0 && !bid.punksmarketBidId"
                  class="unfunded-pill"
                  title="Stash balance is below this bid amount">
                  unfunded
                </div>
                <span
                  class="bid-type-pill"
                  [class.trait]="bid.bidType === 'trait'"
                  [class.custom]="bid.bidType === 'custom'"
                  [class.owner]="bid.bidType === 'owner'"
                  [class.collection]="bid.bidType === 'collection'"
                  [class.onchain]="bid.punksmarketBidId">
                  {{ bid.bidTypeLabel }}
                </span>
                <ng-container *ngIf="bid.bidType === 'owner' && bid.ownerAddress">
                  <div class="tags-list">
                    <a class="tag-pill owner-link" [routerLink]="['/', 'user', bid.ownerAddress]">
                      Owner: <app-wallet-address [address]="bid.ownerAddress"></app-wallet-address>
                    </a>
                  </div>
                </ng-container>
                <ng-container *ngIf="bid.decodedTags?.length && bid.bidType !== 'custom' && bid.bidType !== 'owner'">
                  <div class="tags-list">
                    <span class="tag-pill" *ngFor="let tag of bid.decodedTags">{{ tag }}</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="(bid.bidType === 'custom' || bid.bidType === 'trait') && (bid.punkIndices?.length || bid.punk_indices_count)">
                  <div class="tags-list tags-list-preview">
                    <span class="tag-pill" *ngFor="let tag of bid.punkIndices">
                      #{{ tag }}
                      <div class="punk-popup">
                        <img 
                          [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (tag | tokenIdParse) + '.svg'"
                          [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                          width="30" 
                          height="30" />
                      </div>
                    </span>
                    <span class="tag-pill tag-pill-more" *ngIf="(bid.punk_indices_count ?? bid.punkIndices?.length ?? 0) > 3">+ {{ (bid.punk_indices_count ?? bid.punkIndices?.length ?? 0) - 3 }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="bidder-info" *ngIf="bid.bidder_address">
              <span class="detail-value" style="font-weight: 600; font-size: 11px !important; opacity: 0.4">Bidder:</span>
              <a class="bidder-link" [routerLink]="['/', 'user', bid.bidder_address]">
                <app-wallet-address [address]="bid.bidder_address"></app-wallet-address>
              </a>
            </div>
          </div>
        </div>
                
        <div class="bid-actions">
          <div *ngIf="(bid.sources && bid.sources.length > 0) || bid.source" class="source-pills">
            <span 
              *ngFor="let source of (bid.sources || (bid.source ? [bid.source] : []))" 
              class="source-pill"
              [class.source-cryptopunks-eth-limo]="source === 'cryptopunks.eth.limo'"
              [class.source-cryptopunks-app]="source === 'cryptopunks.app'">
              {{ source }}
            </span>
          </div>
          <div
            *ngIf="bid.isDelegated"
            tippy
            [options]="bid.cancelButtonTooltipOptions">
            <button 
              (click)="cancelBid(bid)" 
              class="btn cancel-btn disabled"
              [attr.disabled]="true">
              Cancel
            </button>
          </div>
          <button 
            *ngIf="!bid.isDelegated && canCancelOutgoingBid(bid)"
            (click)="cancelBid(bid)" 
            class="btn cancel-btn">
            Cancel
          </button>
        </div>        
      </div>
    </div>
  </div>
  </div>

  <!-- Incoming Bids Tab Content -->
  <div *ngIf="activeTab === 'incoming' && showIncomingBidsTab" class="tab-content">
    <!-- Loading State -->
    <div *ngIf="loadingIncomingBids" class="loading-state">
      <p>Loading incoming bids...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="errorIncomingBids && !loadingIncomingBids" class="error-state">
      <p>{{ errorIncomingBids }}</p>
    </div>

    <!-- Bids List -->
    <div *ngIf="!loadingIncomingBids && !errorIncomingBids && (incomingBids$ | async) as incomingBids">
      <div *ngIf="incomingBids.length === 0" class="no-bids">
        <p>No incoming bids found.</p>
      </div>

      <div *ngIf="incomingBids.length > 0" class="incoming-bids-list">
        <div *ngFor="let bid of incomingBids; trackBy: trackByBidId" class="incoming-bid-item">
          <div class="bid-main-info">
            <div class="bid-amount-compact">
              <span class="amount-value">{{ bid.bid_amount_eth | number:'1.2-2' }}</span>
              <div class="amount-currency-row">
                <span class="amount-currency">ETH</span>
                <ng-container
*ngTemplateOutlet="bidIdIcon; context: { id: bid.id, additionalBidIds: bid.additionalBidIds, bid: bid }">
              </ng-container>
              </div>
            </div>
            <div class="bid-details-compact">
              <div class="bidder-info-compact">
                <span class="detail-label">Bidder:</span>
                <a [routerLink]="['/', 'user', bid.bidder_address]" class="bidder-link">
                  <app-wallet-address [address]="bid.bidder_address" [maxVisibleChars]="8"></app-wallet-address>
                </a>
              </div>
              <div class="bid-type-compact">
                <span 
                  class="bid-type-pill-compact"
                  [class.trait]="bid.bidType === 'trait'"
                  [class.custom]="bid.bidType === 'custom'"
                  [class.owner]="bid.bidType === 'owner'"
                  [class.collection]="bid.bidType === 'collection'"
                  [class.legacy]="bid.bidType === 'legacy' || bid.isLegacyBid"
                  [class.onchain]="bid.punksmarketBidId">
                  {{ bid.bidTypeLabel || (bid.bidType === 'trait' ? 'Trait' : bid.bidType === 'owner' ? 'Owner' : bid.bidType === 'custom' ? 'Custom' : bid.bidType === 'legacy' || bid.isLegacyBid ? 'Legacy' : 'Collection') }}
                </span>
                <span *ngIf="bid.confidential" class="confidential-pill-compact" title="Confidential bid">
                  <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor">
                    <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/>
                  </svg>
                </span>
                <span
                  *ngIf="bid.stash_funded === 0 && !bid.punksmarketBidId"
                  class="unfunded-pill unfunded-pill-compact"
                  title="Stash balance is below this bid amount">
                  unfunded
                </span>
              </div>
              <div *ngIf="bid.expires_at" class="bid-expires-compact">
                <span class="detail-label">Expires:</span>
                <span class="detail-value">{{ bid.expires_at | date:'short' }}</span>
              </div>
              <!-- Matching punks frise (matching if any, otherwise all owned since list is filtered by owned) -->
              <div *ngIf="bid.punksForFrise && bid.punksForFrise.length > 0" class="matching-punks-frise">
                <div class="punks-frise-container">
                  <div 
                    *ngFor="let punkId of bid.punksForFrise.slice(0, 7); trackBy: trackByPunkId" 
                    class="punk-frise-item"
                    [routerLink]="['/', 'details', punkId]"
                    (click)="$event.stopPropagation()">
                    <img 
                      [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
                      [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                      width="30" 
                      height="30"
                      [alt]="'Punk ' + punkId" />
                  </div>
                  <span *ngIf="bid.punksForFrise.length > 7" class="more-punks-indicator">
                    and {{ bid.punksForFrise.length - 7 }} more
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="bid-actions-compact">
            <div *ngIf="(bid.sources && bid.sources.length > 0) || bid.source" class="source-pills">
              <span
                *ngFor="let source of (bid.sources || (bid.source ? [bid.source] : []))"
                class="source-pill"
                [class.source-cryptopunks-eth-limo]="source === 'cryptopunks.eth.limo'"
                [class.source-cryptopunks-app]="source === 'cryptopunks.app'">
                {{ source }}
              </span>
            </div>
            <div
              tippy
              [options]="isUsingDelegatedWallet ? acceptButtonTooltipOptions : (isSameWalletStashBid(bid) ? acceptSameWalletTooltipOptions : undefined)">
              <button
                (click)="canAcceptStashBid(bid) && onAcceptStashBid(bid)"
                class="btn accept-btn-compact"
                [class.disabled]="!canAcceptStashBid(bid)"
                [attr.disabled]="!canAcceptStashBid(bid) ? true : null">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Overlay -->
<div
  class="modal-overlay"
  [class.active]="cancelBidConfirmationModalActive || cancelAllBidsConfirmationModalActive || depositModalActive || withdrawModalActive || emailModalActive || settingsModalActive || (isMyBidsTransactionActive && (txTrackingSvc.txModalActive$ | async))"
  [class]="(isMyBidsTransactionActive && (txTrackingSvc.txModalActive$ | async)) ? 'transaction' : ''">

  <div class="modal" [class.deposit-withdraw-modal]="depositModalActive || withdrawModalActive" [class.select-punk-modal]="selectPunkForBidModalActive">
    <!-- Transaction Tracking Modal - Dedicated to my-bids -->
    <ng-container *ngIf="isMyBidsTransactionActive && (txTrackingSvc.txModalActive$ | async)">
      <button class="close-modal" (click)="txTrackingSvc.closeTxModal(); isMyBidsTransactionActive = false">x</button>

      <ng-container *ngFor="let status of txTrackingSvc.txStatusArray; let i = index">
        <ng-container *ngIf="status.active">
          <h3>
            <img
              src="/assets/loader-{{ themeSvc.theme$ | async }}.gif"
              width="20" height="20"
              *ngIf="i === 0 || i === 1"
            />
            {{ status.title }}
          </h3>
          
          <span class="p-wrapper" [innerHTML]="status.message || ''"></span>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- Cancel Bid Confirmation Modal -->
    <ng-container *ngIf="cancelBidConfirmationModalActive && !(isMyBidsTransactionActive && (txTrackingSvc.txModalActive$ | async))">
      <button class="close-modal" (click)="closeCancelBidConfirmation()">x</button>
      
      <div class="punk-info">
        <h2>Cancel Bid</h2>
        <p *ngIf="selectedBidForCancellation">
          Are you sure you want to cancel your bid of 
          <strong>{{ selectedBidForCancellation.bid_amount_eth | number:'1.4-4' }} ETH</strong>?
        </p>
        <p>This action cannot be undone.</p>
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeCancelBidConfirmation()">Cancel</button>
        <button class="submit" (click)="confirmCancelBid()">Confirm Cancel</button>
      </div>
    </ng-container>

    <!-- Cancel All Bids Confirmation Modal -->
    <ng-container *ngIf="cancelAllBidsConfirmationModalActive && !(isMyBidsTransactionActive && (txTrackingSvc.txModalActive$ | async)) && !depositModalActive && !withdrawModalActive && !emailModalActive">
      <button class="close-modal" (click)="closeCancelAllBidsConfirmation()">x</button>
      
      <div class="punk-info">
        <h2>Cancel All Bids</h2>
        <p>
          Are you sure you want to cancel all <strong>{{ bids.length }}</strong> bid(s)?
        </p>
        <p>This will cancel all your active bids. This action cannot be undone.</p>
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeCancelAllBidsConfirmation()">Cancel</button>
        <button class="submit" (click)="confirmCancelAllBids()">Confirm Cancel</button>
      </div>
    </ng-container>

    <!-- Deposit Modal -->
    <ng-container *ngIf="depositModalActive && !(isMyBidsTransactionActive && (txTrackingSvc.txModalActive$ | async)) && !withdrawModalActive && !emailModalActive">
      <button class="close-modal" (click)="closeDepositModal()">x</button>
      
      <div class="punk-info">
        <h2>Deposit to Stash</h2>
        <p>Enter the amount in ETH to deposit to your stash.</p>
      </div>

      <div class="form-group">
        <label for="deposit-amount">Amount (Ξ)</label>
        <input 
          type="number" 
          id="deposit-amount" 
          class="shared-input"
          [(ngModel)]="depositAmount" 
          (ngModelChange)="onDepositAmountChange()"
          placeholder="0" 
          step="0.001"
          min="0"
        />
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeDepositModal()">Cancel</button>
        <button 
          class="submit" 
          (click)="confirmDeposit()"
          [class.disabled]="!canDepositFlag">
          Deposit
        </button>
      </div>
    </ng-container>

    <!-- Withdraw Modal -->
    <ng-container *ngIf="withdrawModalActive && !(isMyBidsTransactionActive && (txTrackingSvc.txModalActive$ | async)) && !depositModalActive && !emailModalActive">
      <button class="close-modal" (click)="closeWithdrawModal()">x</button>
      
      <div class="punk-info">
        <h2>Withdraw from Stash</h2>
        <p>Enter the amount in ETH to withdraw from your stash.</p>
      </div>

      <div class="form-group">
        <label for="withdraw-amount">Amount (Ξ)</label>
        <div class="input-with-action">
          <input 
            type="number" 
            id="withdraw-amount" 
            class="shared-input"
            [(ngModel)]="withdrawAmount" 
            (ngModelChange)="onWithdrawAmountChange()"
            placeholder="0" 
            step="0.001"
            min="0"
            [max]="stashBalanceEth"
          />
          <button 
            type="button"
            class="max-button"
            (click)="setMaxWithdrawAmount()">
            Max
          </button>
        </div>
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeWithdrawModal()">Cancel</button>
        <button 
          class="submit" 
          (click)="confirmWithdraw()"
          [class.disabled]="!canWithdrawFlag">
          Withdraw
        </button>
      </div>
    </ng-container>

    <!-- Settings Modal -->
    <ng-container *ngIf="settingsModalActive && !(isMyBidsTransactionActive && (txTrackingSvc.txModalActive$ | async)) && !depositModalActive && !withdrawModalActive && !emailModalActive">
      <button class="close-modal" (click)="closeSettingsModal()">x</button>
      
      <div class="punk-info">
        <h2>Bids Settings</h2>
        <p>Configure how your bids are displayed.</p>
      </div>

      <div class="toggle-wrapper">
        <div class="sales-only-toggle" (click)="toggleDisplayOnlyHigherBidPerToken()">
          <div class="label">Show top bid per Punk only</div>
          <div class="toggle" [class.on]="displayOnlyHigherBidPerToken">
            <div></div>
          </div>
        </div>
      </div>

      <div class="toggle-wrapper">
        <div class="sales-only-toggle" (click)="toggleDisplayOnlyBidsAboveMinEth()">
          <div class="label">Hide bids under {{ minBidEthConfig }} ETH</div>
          <div class="toggle" [class.on]="displayOnlyBidsAboveMinEth">
            <div></div>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeSettingsModal()">Close</button>
      </div>
    </ng-container>

  </div>
</div>

<!-- Select Punk for Bid Modal -->
<app-select-punk-modal
  [isActive]="selectPunkForBidModalActive"
  [bid]="selectedStashBid"
  [matchingPunkIds]="matchingPunkIdsForBid"
  (closed)="closeSelectPunkModal()"
  (punkSelected)="onPunkSelected($event)">
</app-select-punk-modal>
